<app-topnav [pageName]="pageName"></app-topnav>
<div class="container">
  <div class="content user-mgmt-page" role="main">
    <header class="user-mgmt-page__header">
      <div>
        <h1 class="user-mgmt-page__title">Materials</h1>
        <p class="user-mgmt-page__subtitle">Search, filter, and manage course materials and resources.</p>
        @if (totalRecords > 0) {
          <div class="user-mgmt-page__meta">
            <span class="user-mgmt-page__count">{{ totalRecords | number }} materials found</span>
          </div>
        }
      </div>
      <div class="user-mgmt-page__actions">
        @if (showaddbutton) {
          <a routerLink="/add-material" class="user-mgmt-page__btn user-mgmt-page__btn--primary">
            <mat-icon>add</mat-icon>
            Add Material
          </a>
        }
      </div>
    </header>

    <section class="user-mgmt-page__filters">
      <form (ngSubmit)="search()">
        <div class="user-mgmt-page__filters-grid user-mgmt-page__filters-grid--wide">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Search</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput class="form-control-textbox" name="filterSearch" [(ngModel)]="queryFilter.MaterialNameKeyword" placeholder="Material name" />
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Type</mat-label>
            <mat-select placeholder="All Types" name="filtermaterialtype" [(ngModel)]="queryFilter.Type">
              <mat-option value="0">All Types</mat-option>
              @for (mt of materialTypes; track mt) {
                <mat-option [value]="mt.id">{{ mt.type }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Language</mat-label>
            <mat-select placeholder="All Languages" name="filtermateriallanguage" [(ngModel)]="queryFilter.Language">
              <mat-option value="0">All Languages</mat-option>
              @for (lang of materialLanguage; track lang) {
                <mat-option [value]="lang.id">{{ lang.description }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Course</mat-label>
            <mat-select placeholder="All Courses" name="filtermaterialcouse" [(ngModel)]="queryFilter.Course">
              <mat-option value="0">All Courses</mat-option>
              @for (course of courseList; track course) {
                <mat-option [value]="course.id">{{ course.courseName }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Status</mat-label>
            <mat-select placeholder="All Statuses" name="filtermaterialstatus" [(ngModel)]="queryFilter.Status">
              <mat-option value="0">All Statuses</mat-option>
              @for (ms of materialStatus; track ms) {
                <mat-option [value]="ms.key">{{ ms.value }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="user-mgmt-page__filters-actions">
          <button class="user-mgmt-page__btn user-mgmt-page__btn--primary" type="submit" #submitButton>
            <mat-icon>filter_list</mat-icon>
            Apply Filters
          </button>
          <button class="user-mgmt-page__btn user-mgmt-page__btn--secondary" type="button" (click)="resetFilters()">
            <mat-icon>restart_alt</mat-icon>
            Reset
          </button>
        </div>
      </form>
    </section>

    <section class="user-mgmt-page__table-card">
      <ng-container *ngTemplateOutlet="tagTable; context: { data: materiallist, headerVisible: true }"></ng-container>
      <mat-paginator
        #paginator
        [length]="totalRecords"
        [pageSize]="25"
        [hidden]="totalRecords === 0"
        [pageSizeOptions]="[10, 25, 50]"
        (page)="handlePageEvent($event)"
        aria-label="Material list pagination">
      </mat-paginator>
    </section>
  </div>
</div>

<ng-template #tagTable let-data="data" let-headerVisible="headerVisible">
  <app-no-results #noResults></app-no-results>

  <table mat-table class="fileList primary" [dataSource]="data" [hidden]="data.length === 0">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Material Name</th>
      <td mat-cell *matCellDef="let material">
        <a [routerLink]="['/view-material', material.id]" class="user-mgmt-page__user-link">{{ material.materialName }}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let material">{{ material.materialId }}</td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell *matCellDef="let material">{{ material.type }}</td>
    </ng-container>

    <ng-container matColumnDef="language">
      <th mat-header-cell *matHeaderCellDef>Language</th>
      <td mat-cell *matCellDef="let material">{{ material.language }}</td>
    </ng-container>

    <ng-container matColumnDef="course">
      <th mat-header-cell *matHeaderCellDef>Course</th>
      <td mat-cell *matCellDef="let material">
        @if (material.course?.length) {
          <ul class="user-mgmt-page__chip-list">
            @for (course of material.course; track course) {
              <li>
                <span class="user-mgmt-page__chip user-mgmt-page__chip--program">{{ course }}</span>
              </li>
            }
          </ul>
        } @else {
          <span class="user-mgmt-page__empty-text">—</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>
        Status
        <app-information-popup [information]="information"></app-information-popup>
      </th>
      <td mat-cell *matCellDef="let material">
        <app-status-bubble [status]="material.status"></app-status-bubble>
      </td>
    </ng-container>

    @if (headerVisible) {
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="tableHeader"></tr>
    }
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
  </table>
</ng-template>

<app-footer></app-footer>
